<section #customFields>
  <div class="d-flex flex-row justify-content-between align-items-center">
    <div class="w-100">
      <h1 class="pt-3 mb-2">Custom fields</h1>
      <div class="col-xl-9 pl-0">
        <p class="mb-2">
          Properties are fields that store information on TablesReady visits. You can track new inputs
          like email address or loyalty information when adding customers and managing your list.
        </p>
        <p class="mb-2">
          Fields can be enabled for different pages. E.g., if you enable a field for Public Viewing, the field contents will be displayed on your public waitlist page. Or, if you enable a field for Private Adding, the field will only be shown as an input on the add to waitlist and add to {{reservationPlural}} forms.
        </p>
        <p class="mb-2">
          Additionally, you can choose to make a field required on the public add pages before they can be submitted.
        </p>
        <p>
          Last, you can add the field to the Customers database, save the information there, and automatically have it pulled up when a customer is recognized by their phone number.
        </p>
      </div>
    </div>
  </div>

  <div class="w-100 d-flex justify-content-end">
    <div>
      <button
        type="button"
        class="btn btn-info"
        (click)="addNewField()"
        [disabled]="isAddingNewField"
      >+ Add property</button>
    </div>
  </div>

  <div *ngIf="fields"  class="d-flex flex-row justify-content-center w-100" style="overflow-x: auto">
    <form class="w-100">
      <table class="fields-table w-100">
        <thead>
        <tr class="fields-header" *ngIf="fullSize">
          <th [ngClass]="'column-drag-and-drop' + (fullSize ? '' : '-tablet')"></th>
          <th class="column-property-name text-center">PROPERTY & PLACEHOLDER</th>
          <th class="column-property-type text-center">PROPERTY TYPE</th>
          <th class="text-center">SELECT OPTIONS</th>
          <th class="column-public-private"></th>
          <th class="column-view text-center required-text short">VIEW</th>
          <th class="column-add text-center required-text short">ADD</th>
          <th class="column-required text-center required-text">REQUIRED</th>
          <th class="column-customer text-center required-text">
            <div class="d-flex flex-row justify-content-center align-items-center flex-nowrap">
              <span>CUSTOMER</span>
              <span class="bi bi-info-circle-fill info-badge ml-1 cursor-help" [ngbTooltip]="'Save to Customer'"></span>
            </div>
          </th>
          <th class="column-enabled text-center required-text">ENABLED</th>
          <th class="column-actions text-center">ACTIONS</th>
        </tr>
        </thead>

        <tbody cdkDropList (cdkDropListDropped)="fieldMoved.emit($event)">
        <tr
          cdkDrag
          *ngFor="let control of fields.controls; let i = index; trackBy: trackBy"
          [cdkDragDisabled]="isNewField(control) || control.get('id').value === selectedFieldIdToEdit"
          [formGroup]="control"
          class="fields-body"
          [class.fields-body-selected]="isNewField(control) || control.get('id').value === selectedFieldIdToEdit"
        >
          <td [ngClass]="'column-drag-and-drop' + (fullSize ? '' : '-tablet')">
            <div class="d-flex flex-row justify-content-center align-items-center">
              <div
                cdkDragHandle
                class="halftone"
              ></div>
            </div>
          </td>

          <td class="column-property-name" [class.w-100]="!fullSize">
            <div *ngIf="fullSize" class="d-flex flex-column justify-content-center align-items-center">
              <div class="pr-2">
                <ng-container *ngTemplateOutlet="nameColumn; context: { control }"></ng-container>
              </div>
            </div>

            <div *ngIf="!fullSize" class="d-flex flex-column pr-3">
              <div class="d-flex justify-content-between">
                <div class="mobile-column px-2">
                  <p class="m-0">PROPERTY & PLACEHOLDER</p>
                  <ng-container *ngTemplateOutlet="nameColumn; context: { control }"></ng-container>
                </div>

                <div class="mobile-column dropdown-min-width px-1">
                  <p class="m-0">PROPERTY TYPE</p>
                  <ng-container *ngTemplateOutlet="propertyTypeColumn; context: { control }"></ng-container>
                </div>

                <div class="mobile-column dropdown-min-width px-2">
                  <p class="m-0">SELECT OPTIONS</p>
                  <ng-container *ngTemplateOutlet="selectOptionsColumn; context: { control }"></ng-container>
                </div>

                <div class="mobile-column px-2">
                  <ng-container *ngTemplateOutlet="closeBtn; context: { id: control.get('id').value }"></ng-container>
                </div>
              </div>

              <div class="tablet-divider pt-3 mt-3 border-border d-flex justify-content-between">
                <table class="w-100 small-table" border="0" cellspacing="0" cellpadding="0">
                  <tr>
                    <th></th>
                    <th class="required-text short">VIEW</th>
                    <th class="required-text short">ADD</th>
                    <th class="required-text">REQUIRED</th>
                    <th class="required-text">CUSTOMER</th>
                    <th class="required-text">ENABLED</th>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <ng-container *ngTemplateOutlet="checkboxDescriptionColumn"></ng-container>
                      </div>
                    </td>
                    <td>
                      <div class="required-text short">
                        <ng-container
                          *ngTemplateOutlet="viewColumn; context: { visibilityGroup: control.get('visibility') }"
                        ></ng-container>
                      </div>
                    </td>
                    <td>
                      <div class="required-text short">
                        <ng-container
                          *ngTemplateOutlet="addColumn; context: { visibilityGroup: control.get('visibility') }"
                        ></ng-container>
                      </div>
                    </td>
                    <td>
                      <div class="required-text">
                        <ng-container
                          *ngTemplateOutlet="requiredColumn; context: { visibilityGroup: control.get('visibility') }"
                        ></ng-container>
                      </div>
                    </td>
                    <td>
                      <div class="required-text">
                        <ng-container
                          *ngTemplateOutlet="customerColumn; context: { control: control.get('customer') }"
                        ></ng-container>
                      </div>
                    </td>
                    <td>
                      <div class="required-text d-flex justify-content-center h-100 align-items-start">
                        <ng-container
                          *ngTemplateOutlet="enabledSwitcher; context: { control: control.get('enabled') }"
                        ></ng-container>
                      </div>
                    </td>
                  </tr>
                </table>

                <div class="d-flex align-items-end">
                  <ng-container
                    *ngTemplateOutlet="actions; context: { idControl: control.get('id').value, control: control, index: i }"
                  ></ng-container>
                </div>
              </div>
            </div>
          </td>

          <td *ngIf="fullSize" class="column-property-type">
            <div class="d-flex flex-column justify-content-between align-items-center">
              <div class="px-2">
                <ng-container *ngTemplateOutlet="propertyTypeColumn; context: { control }"></ng-container>
              </div>
            </div>
          </td>

          <td *ngIf="fullSize" class="column-select-options">
            <div class="px-2">
              <ng-container *ngTemplateOutlet="selectOptionsColumn; context: { control }"></ng-container>
            </div>
          </td>

          <td *ngIf="fullSize" class="column-public-private pl-2">
            <ng-container *ngTemplateOutlet="checkboxDescriptionColumn"></ng-container>
          </td>

          <td *ngIf="fullSize" class="column-view">
            <ng-container *ngTemplateOutlet="viewColumn; context: { visibilityGroup: control.get('visibility') }"></ng-container>
          </td>

          <td *ngIf="fullSize" class="column-add">
            <ng-container *ngTemplateOutlet="addColumn; context: { visibilityGroup: control.get('visibility') }"></ng-container>
          </td>

          <td *ngIf="fullSize" class="column-required">
            <ng-container *ngTemplateOutlet="requiredColumn; context: { visibilityGroup: control.get('visibility') }"></ng-container>
          </td>

          <td *ngIf="fullSize" class="column-customer">
            <div class="d-flex flex-row justify-content-center align-items-center">
              <ng-container *ngTemplateOutlet="customerColumn; context: { control: control.get('customer') }"></ng-container>
            </div>
          </td>

          <td *ngIf="fullSize" class="column-enabled">
            <div class="d-flex flex-row justify-content-center align-items-center">
              <ng-container *ngTemplateOutlet="enabledSwitcher; context: { control: control.get('enabled') }"></ng-container>
            </div>
          </td>

          <td *ngIf="fullSize" class="column-actions">
            <div class="d-flex flex-row justify-content-center align-items-center">
              <ng-container
                *ngTemplateOutlet="actions; context: { idControl: control.get('id').value, control: control, index: i }"
              ></ng-container>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </form>
  </div>

  <div class="d-flex flex-row justify-content-center align-items-center py-4 gap-1">
    <button class="btn btn-success" (click)="submit(); selectedFieldIdToEdit = undefined" [disabled]="submitting || !fields.valid || !fields.dirty">Save</button>
    <button class="btn btn-danger" (click)="resetData()">Reset</button>
  </div>
</section>

<ng-template #nameColumn let-control="control">
  <span
    class="mt-2 d-flex flex-column justify-content-center align-items-center"
    *ngIf="!isNewField(control) && control.get('id').value !== selectedFieldIdToEdit"
  >
    <p class="mb-0 field-name"
       [innerText]="control.get('name').value"
    ></p>
    <p class="mb-0 field-placeholder"
       [class.invisible]="control.get('placeholder').value === ''"
       [innerText]="control.get('placeholder').value"
    ></p>
  </span>

  <div class="d-flex flex-column" *ngIf="isNewField(control) || selectedFieldIdToEdit === control.get('id').value">
    <control-messages [control]="control.get('name')"></control-messages>
    <input type="text" class="form-control dropdown-min-width border-radius-bottom-0" placeholder="Custom property name" [formControl]="control.get('name')" />
    <input type="text" class="form-control dropdown-min-width border-radius-top-0" placeholder="Custom property placeholder" [formControl]="control.get('placeholder')" />
    <control-messages [control]="control.get('placeholder')"></control-messages>
  </div>
</ng-template>

<ng-template #propertyTypeColumn let-control="control">
  <span [ngClass]="selectedFieldIdToEdit === control.get('id').value ? 'mt-edit' : 'mt-add'">
    <p
      class="mb-0 text-center text-nowrap"
      [innerText]="fieldTypeMap[control.get('type').value] | titlecase"
      *ngIf="!isNewField(control) && control.get('id').value !== selectedFieldIdToEdit"
    ></p>

  <frontend-dropdown
    *ngIf="isNewField(control) || selectedFieldIdToEdit === control.get('id').value"
    [items]="types"
    bindLabel="name"
    bindValue="value"
    [formControl]="control.get('type')"
    elementId="custom-field-type-{{ control.get('id').value }}"
    minWidth="12rem"
  ></frontend-dropdown>
  </span>
</ng-template>

<ng-template #selectOptionsColumn let-control="control">
  <div *ngIf="!isNewField(control) && control.get('id').value !== selectedFieldIdToEdit">
    <p class="mb-0 text-center" *ngIf="(control.get('type').value !== fieldTypes.select && control.get('type').value !== fieldTypes.multiSelect) || !control.get('options').value.length; else selectOptions">N/A</p>

    <ng-template #selectOptions>
      <div class="mt-1 dropdown-min-width">
        <tablesready-select-options
          [options]="control.get('options').value"
          [maxSelectOptionsToDisplay]="maxSelectOptionsToDisplay"
        ></tablesready-select-options>
      </div>
    </ng-template>
  </div>

  <frontend-dropdown-plain
    *ngIf="(control.get('type').value === fieldTypes.select || control.get('type').value === fieldTypes.multiSelect) && (isNewField(control) || selectedFieldIdToEdit === control.get('id').value)"
    [multiple]="true"
    [addTag]="true"
    [items]="control.get('options')?.value"
    [virtualScroll]="true"
    [formControl]="control.get('options')"
    [clearable]="true"
    minWidth="12rem"
    placeholder="Enter select options"
    elementId="custom-field-multiselect-options-{{ control.get('id').value }}"
  ></frontend-dropdown-plain>
  <control-messages [control]="control.get('options')"></control-messages>
</ng-template>

<ng-template #checkboxDescriptionColumn>
  <div class="d-flex flex-row justify-content-center align-items-center">
    <div class="d-flex flex-column align-items-end justify-content-center">
      <p class="mb-2 field-placeholder">PUBLIC</p>
      <p class="mt-1 mb-0 field-placeholder">PRIVATE</p>
    </div>
  </div>
</ng-template>

<ng-template #viewColumn let-visibilityGroup="visibilityGroup">
  <ng-container [formGroup]="visibilityGroup">
    <div class="d-flex flex-column justify-content-start align-items-center mt-2">
      <ng-container [formGroup]="visibilityGroup.get('public')">
        <label [class.tablet-area]="!fullSize">
          <input type="checkbox" [formControl]="visibilityGroup.get('public.view')" />
        </label>
      </ng-container>

      <ng-container [formGroup]="visibilityGroup.get('private')">
        <label [class.tablet-area]="!fullSize">
          <input type="checkbox" [formControl]="visibilityGroup.get('private.view')" />
        </label>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #addColumn let-visibilityGroup="visibilityGroup">
  <ng-container [formGroup]="visibilityGroup">
    <div class="d-flex flex-column justify-content-start align-items-center mt-2">
      <ng-container [formGroup]="visibilityGroup.get('public')">
        <label [class.tablet-area]="!fullSize">
          <input type="checkbox" [formControl]="visibilityGroup.get('public.add')" />
        </label>
      </ng-container>

      <ng-container [formGroup]="visibilityGroup.get('private')">
        <label [class.tablet-area]="!fullSize">
          <input type="checkbox" [formControl]="visibilityGroup.get('private.add')" />
        </label>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #requiredColumn let-visibilityGroup="visibilityGroup">
  <ng-container [formGroup]="visibilityGroup">
    <div class="d-flex flex-column justify-content-start align-items-center mt-2">
      <ng-container [formGroup]="visibilityGroup.get('public')">
        <label [class.tablet-area]="!fullSize">
          <input type="checkbox" [formControl]="visibilityGroup.get('public.required')" />
        </label>
      </ng-container>

      <ng-container [formGroup]="visibilityGroup.get('private')">
        <label [class.tablet-area]="!fullSize">
          <input type="checkbox" [formControl]="visibilityGroup.get('private.required')"/>
        </label>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #enabledSwitcher let-control="control">
  <tablesready-switcher [formControl]="control"></tablesready-switcher>
</ng-template>

<ng-template #customerColumn let-control="control">
  <div class="d-flex flex-column justify-content-start align-items-center mt-2">
    <label [class.tablet-area]="!fullSize">
      <input type="checkbox" [formControl]="control" />
    </label>

    <label [class.tablet-area]="!fullSize">
      <input class="invisible" type="checkbox" [formControl]="control" />
    </label>
  </div>
</ng-template>

<ng-template #actions let-idControl="idControl" let-control="control" let-index="index">
  <div *ngIf="fullSize">
    <ng-container *ngTemplateOutlet="closeBtn; context: { id: idControl }"></ng-container>
  </div>

  <div
    class="d-flex flex-row actions"
    [class.tablet-cell-actions]="!fullSize"
    *ngIf="!isNewField(control) && idControl !== selectedFieldIdToEdit"
  >
    <button
      type="button"
      class="btn btn-info"
      (click)="selectedFieldIdToEdit = idControl"
    >
      <tr-icon [icon]="icon.edit" [color]="iconColor.white"></tr-icon>
    </button>

    <button type="button" class="btn btn-outline-danger" (click)="fieldRemoved.emit(index)">Delete</button>
  </div>
</ng-template>

<ng-template #closeBtn let-id="id">
  <div
    class="d-flex flex-row justify-content-center align-items-center"
    *ngIf="id === selectedFieldIdToEdit"
  >
    <button class="btn btn-outline-info" (click)="close()">Close</button>
  </div>
</ng-template>
